// cypress testid identifier
export const testId = (testKey: string) => ({'data-cy': testKey, 'data-testId': testKey});
